module.exports = __webpack_public_path__ + "img/marker.fccc2668.svg";